import React, { Fragment, useState, useEffect } from 'react';

const Loader = () => {
  const [show, setShow] = useState(true);
  useEffect(() => {

  }, []);
  return (
    <>
      <div className={`loader-wrapper ${show ? '' : 'loderhide'}`}>
        <div className="loader bg-white">
          <div className="whirly-loader"> </div>
        </div>
      </div>
    </>
  );
};

export default Loader;
